/* eslint-disable max-len */
import React, { Fragment, useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css';
import {formatDate} from '../../../../../../CommonComponent/dateConverter'
import { Listbox, Transition } from '@headlessui/react';
import { timeDifference, timezoneValues } from '../../../../../../CommonComponent/staticValues';
import ToolTip from '../../../../../../CommonComponent/tooltip';
import { useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import disableFieldsBasedOnAuctionStatus from '../../../../disableFieldsBasedOnAuctionStatus';
import GooglePlacesDropdown from '../../../../../../CommonComponent/GooglePlacesDropdown';
import { fetchTimeZone } from '../../../../../../CommonComponent/fetchTimeZone';
import { getCurrentOffset } from '../../../../../../CommonComponent/getCurrentOffset';

export default function SetUpAuctionDates({auctionData,setAuctionData, startDate,setStartDate,
    startHour,setStartHour, edit,
    startMin,setStartMin, setEditedAuctionData,date,
    startDateBeforeCurrent, setStartDateBeforeCurrent}) {
    const state = useLocation()
    const currentDate = new Date();

    useEffect(()=>{

        const updateStartTimestamps = async () => {
            const start = new Date(startDate);
        
            const syear = start.getFullYear();
            const smonth = start.getMonth(); // 0-based
            const sdate = start.getDate();

            start.setHours(0, 0, 0, 0);
            const startTimestamp = Date.UTC(syear, smonth, sdate, parseInt(startHour), parseInt(startMin), 0, 0);

            let startTimezone = '';

            if (auctionData.location && auctionData.location.address!=='') {
                if(auctionData.location?.address == state.state?.location.address && 
                    auctionData.start_date == state.state?.start_date) {
                    startTimezone = auctionData.time_zone || 'Etc/UTC';
                }else{
                    const timezoneData = await fetchTimeZone(
                        auctionData.location.latitude,
                        auctionData.location.longitude,
                        Math.floor(startTimestamp /1000)
                    );
                    startTimezone = timezoneData?.data?.timeZoneId || 'Etc/UTC';
                }
            } else if (auctionData.time_zone!=='') {
                startTimezone = auctionData.time_zone;
            } else {
                startTimezone = 'Etc/UTC';
            }

            const IST = moment.tz(startTimezone);
            const startDateTime = IST.clone().set({
                year: syear,
                month: smonth,
                date: sdate,
                hour: startHour,
                minute: startMin,
                second: 0,
                millisecond: 0
            });

            const timestamp = startDateTime.valueOf();

            setEditedAuctionData(prev => ({ ...prev,
                start_date: timestamp ,
                time_zone: auctionData.time_zone || ''
            }));
            setAuctionData(prev => ({ ...prev,
                start_date: timestamp ,
                time_zone: auctionData.time_zone || ''
            }));
        }

        if(Object.keys(auctionData).length > 0 && startDate !== ''){
            updateStartTimestamps();
        }
    },[startDate, startHour, startMin])


    useEffect(()=>{

        if(auctionData.location?.address!== state.state?.location?.address) {

            const start = new Date(startDate);

            const IST = moment.tz(auctionData.start_time_zone?.timeZoneId || auctionData.time_zone || 'Etc/UTC');
            const startDateTime = IST.clone().set({
                year: start.getFullYear(),
                month: start.getMonth(),
                date: start.getDate(),
                hour: startHour,
                minute: startMin,
                second: 0,
                millisecond: 0
            });

            const timestamp = startDateTime.valueOf();

            setEditedAuctionData(prevData=>({...prevData, 
                start_date: timestamp,
            }))

            setAuctionData(prevData=>({...prevData, 
                start_date: timestamp,
            }))
        }

    },[auctionData.location])

    // Validate if start date/time is before current system time
    // useEffect(() => {
    //     if (startDate !== '' && startHour !== '' && startMin !== '') {
    //         const start = new Date(startDate);
    //         const syear = start.getFullYear();
    //         const smonth = start.getMonth();
    //         const sdate = start.getDate();
            
    //         const selectedStartDateTime = new Date(syear, smonth, sdate, parseInt(startHour), parseInt(startMin), 0, 0);
    //         const currentDateTime = new Date();
            
    //         setStartDateBeforeCurrent(selectedStartDateTime < currentDateTime);
    //     } else {
    //         setStartDateBeforeCurrent(false);
    //     }
    // }, [startDate, startHour, startMin]);

    /**
     * Function to return the disabled state 
     * from disabled fields maping based on it's
     * auction status
     * @param {*} field 
     * @returns 
     */
    const returnDisableState = (field)=>{
        let statusCheck = false;
        let status = auctionData?.status ? auctionData.status : "";
        if(status)
            status = status !== "Accepting bids" ? status.toLowerCase() : "acceptingBids"
        switch(field) {
        case "startHour": {
            statusCheck = disableFieldsBasedOnAuctionStatus[`${status}`]?.startHour;
            break;
        }
        case "startMin": {
            statusCheck = disableFieldsBasedOnAuctionStatus[`${status}`]?.startMin;
            break;
        }
        case "timeZone": {
            statusCheck = disableFieldsBasedOnAuctionStatus[`${status}`]?.timeZone;
            break;
        }
        default:
            break;
        }
        return statusCheck;
    }

    const getTimezone = async (lat, lng, address, setSelected) => {
        const timestamp = Math.floor(Date.now() / 1000);
        const {data: startData, formattedOffset: startOffset} = auctionData?.start_date ? await fetchTimeZone(lat, lng, Math.floor(auctionData.start_date / 1000)) : await fetchTimeZone(lat, lng, timestamp); 
                
        setSelected(`${address} (${getCurrentOffset(startData.timeZoneId)})`);
        
        setAuctionData(prevData=>(
            {...prevData, 
                location: {
                    address: address,
                    latitude: lat,
                    longitude: lng,
                },
                time_zone: startData.timeZoneId
            }
        ))
        if(!auctionData.location || auctionData.location?.address !== address) {
            setEditedAuctionData(prevData => ({
                ...prevData,
                location: {
                    address: address,
                    latitude: lat,
                    longitude: lng,
                },
                time_zone: startData.timeZoneId
            }));
        }
        
    };

    return (
        <div id="auction-dates-content" className="auction-dates-content">
            {/* <!-- start date --> */}
            <div className="pt-4 pb-3">
                <div className="flex items-center gap-2">
                    <p className="font-medium text-[#343434] text-[12px] leading-normal" data-testid={date}>Date</p>
                    <ToolTip trigger="click"
                        content="The is the date/time your live event will take place. Pre-bidding will close at this time."
                        tooltipTestId="date-tooltip-content">
                        <img src="/images/info-icon.svg" className={`cursor-pointer`} data-testid='date-tooltip-icon'
                            alt="info-icon" loading="lazy" />
                    </ToolTip>
                </div>                
                <DatePicker
                    disabled={auctionData.status=="Accepting bids"}
                    minDate={currentDate}
                    dateFormat="yyyy-MM-dd HH:mm:ss"
                    selected={startDate}
                    onChange={(startDate) => setStartDate(startDate)}
                    customInput={
                        <div className={`border flex mt-1 relative h-11 py-2.5 focus:border-[#343434] 
                            ${auctionData.status=="Accepting bids" ? "bg-[#F4F4F5] border-[#c9c9cc]" : "border-[#A1A1A9]"} `}>
                            <input id='start-date' autoComplete='off' type="text" disabled={auctionData.status=="Accepting bids"}
                                className={`text-[14px] z-2 pl-3 pr-7 w-full text-start outline-none font-medium 
                                disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] 
                                ${auctionData.status=="Accepting bids" ? 'cursor-default' : 'cursor-pointer'}
                                leading-normal text-[#343434] placeholder:text-[#A1A1A9]`}
                                value={startDate!=='' ? formatDate(startDate):''}
                                placeholder='Select' />
                            <img src="/images/dropdown-icon.png" alt="dropdown-icon"
                                className="absolute cursor-pointer top-[19px] right-4" />
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3.5
                                            pointer-events-none">
                            </div>
                        </div>
                    }
                />
            </div>
            {/* <!-- dropdown for dates--> */}
            <label for="country" className="text-[12px] mt-3 font-medium leading-normal text-[#343434]">Time</label>
            <div className="flex w-full">
                <Listbox as="div" disabled={returnDisableState("startHour")}
                    className="relative w-1/2" value={startHour} onChange={(value) => {setStartHour(value)}}>
                    {({ open }) => (
                        <>
                            <Listbox.Button
                                type="button"
                                className={`text-[14px] text-start relative w-full h-11 px-3 border border-[#A1A1A9] disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                                ${startHour!=='' ? 'text-[#343434]':'text-[#A1A1A9]'} outline-none font-medium leading-normal`}
                                id="hours1"
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"
                                data-testid='startHour'
                                data-te-ripple-init
                                data-te-ripple-color="light"
                            >
                                {`${startHour !== '' ? String(startHour).padStart(2, '0') : 'Hour'}`}
                            </Listbox.Button>
                            <img src="/images/dropdown-icon.png" alt="dropdown-icon" 
                                className="absolute top-[22px] right-[15px]" loading="lazy" />
                            <Listbox.Options 
                                className="bg-white rounded-[8px] z-10 absolute 
                            w-full [data-te-dropdown-show]:block shadow-bs1 h-[155px] customScrollbar 
                            overflow-y-auto overflow-x-hidden " 
                                aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                <div className="pr-[15px] py-1">
                                    {Array.from({ length: 24 }, (_, index) => (
                                        <Listbox.Option key={index} value={index} 
                                            className="pl-[6px] pr-[6px] pt-2 text-[10px]
                                        leading-normal font-medium text-[#4A4A4A] cursor-pointer">
                                            {({ active, selected }) => (
                                                <p className={`${active?'bg-[#E6E6E6]':''} rounded-[11px] px-2 py-1.5`} data-testid={`h-${index}`}>
                                                    {index.toString().padStart(2, '0')}
                                                </p>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </div>
                            </Listbox.Options>
                        </>
                    )}
                </Listbox>
                <Listbox as="div" disabled={returnDisableState("startMin")}
                    className="relative w-1/2 ml-3" value={startMin} onChange={(value) => {setStartMin(value)}}>
                    {({ open }) => (
                        <>
                            <Listbox.Button
                                type="button"
                                className={`text-[14px] text-start relative w-full h-11 px-3 border border-[#A1A1A9] disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                                ${startMin!=='' ?'text-[#343434]':'text-[#A1A1A9]'} outline-none font-medium leading-normal`}
                                id="minutes1"
                                data-testid='startMin'
                                data-te-dropdown-toggle-ref
                                aria-expanded="false"
                                data-te-ripple-init
                                data-te-ripple-color="light"
                            >
                                {`${startMin!=='' ? String(startMin).padStart(2, '0') : 'Mins'}`}
                            </Listbox.Button>
                            <img src="/images/dropdown-icon.png" alt="dropdown-icon" 
                                className="absolute top-[22px] right-[15px]" loading="lazy" />
                            <Listbox.Options 
                                className="bg-white rounded-[8px] z-10 absolute 
                            w-full [data-te-dropdown-show]:block shadow-bs1 h-[155px] customScrollbar 
                            overflow-y-auto overflow-x-hidden" 
                                aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref>
                                <div className="pr-[15px] py-1">
                                    {Array.from({ length: 60 }, (_, index) => (
                                        <Listbox.Option key={index} value={index} 
                                            className="pl-[6px] pr-[6px] pt-2 text-[10px] 
                                        leading-normal font-medium text-[#4A4A4A] cursor-pointer">
                                            {({ active, selected }) => (
                                                <p className={`${active?'bg-[#E6E6E6]':''} rounded-[11px] px-2 py-1.5`} data-testid={`m-${index}`}>
                                                    {index.toString().padStart(2, '0')}
                                                </p>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </div>
                            </Listbox.Options>
                        </>
                    )}
                </Listbox>
            </div>
            {startDateBeforeCurrent &&
                <p className="text-[10px] pt-1.5 font-medium leading-normal text-[#984848]">
                    date/time should be later than current date/time
                </p>}

            {/* <!-- dropdown for timezone--> */}
            <div className="flex mt-4 items-center gap-2">
                <p className="text-[12px] font-medium leading-normal text-[#343434]">Location/Timezone</p>
                <ToolTip trigger="click"
                    content="The timezone that corresponds to the auction countdown clock and 
                                which will be displayed to bidders.">
                    <img src="/images/info-icon.svg" className="cursor-pointer" alt="info-icon" loading="lazy" />
                </ToolTip>
            </div>
            {(!auctionData.location) ? <Listbox as="div" disabled={returnDisableState("timeZone")} value={auctionData.time_zone} className="relative w-full" 
                onChange={(value)=>{
                    setAuctionData(prevData=>({...prevData, time_zone: value.name}))
                    setEditedAuctionData(prevData=>({...prevData, time_zone: value.name}))
                }}>
                {({ open }) => (
                    <>
                        <Listbox.Button type="button" 
                            className={`text-[14px] text-start relative w-full h-11 px-3 border border-[#A1A1A9] disabled:border-[#c9c9cc] disabled:text-[#A1A1A9] disabled:bg-[#F4F4F5]
                                ${auctionData.time_zone!=='' ?'text-[#343434]':'text-[#A1A1A9]'} outline-none font-medium leading-normal`} 
                            id="time-zone">{auctionData.time_zone===''?'Select':auctionData.time_zone +" "+ timeDifference[auctionData.time_zone] }</Listbox.Button>
                        <img src="/images/dropdown-icon.png" alt="dropdown-icon" 
                            className={`absolute top-[20px] right-[15px] 
                            ${open?'rotate-180':'transform-none'}`}
                            loading="lazy" />
                        <Listbox.Options 
                            className="bg-white rounded-[8px] z-30  absolute w-full [&[data-te-dropdown-show]]:block 
                shadow-bs1 list-none" aria-labelledby="time-zone">
                            <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <div className=" pr-[15px] py-1  h-[155px] customScrollbar overflow-y-auto 
                                overflow-x-hidden">
                                    {timezoneValues.map((timezone) => (

                                        <Listbox.Option key={timezone.id} value={timezone} as={Fragment}
                                            className="pl-[18px] pr-[15px] py-2 list-none
                        text-[14px]  leading-normal font-medium text-[#343434]">
                                            {({ active, selected }) => (

                                                <li
                                                    className={`py-2 cursor-pointer rounded-[11px] px-2.5 text-[#343434] ${
                                                        active ? 'bg-[#E6E6E6]' : 'bg-white'
                                                    }`}
                                                >
                                                    {timezone.name} {timeDifference[timezone.name]}
                                                </li>
                                            )}
                                        </Listbox.Option>
                                    ))}
                                </div>
                            </Transition>
                        </Listbox.Options>
                    </>
                )}
            </Listbox> : <GooglePlacesDropdown 
                auctionData={auctionData} getTimezone={getTimezone}
                disabled={returnDisableState("timeZone")} />}
        </div>    
    )
}
